import { ReadMore } from "Components/ReadMore";
import { useTexts } from "Components/TextContext";
import { AlertDescription } from "Components/TextContext/commonComponentEnums";
import { DescriptionNoMargin } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { usePartnerId } from "Store/partners/partnerHooks";
import { Partner } from "Store/partners/partnerInterfaces";
import React from "react";
import { FamilySituation } from "../../../ProductDetails/FormElements/interfaces";

interface Props {
  familySituation: FamilySituation;
}

export const AdviceTextsDeathCommonChildren = ({
  familySituation,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  const isAdvisor = useIsAdvisorSelector();
  const partnerId = usePartnerId();

  if (
    familySituation === FamilySituation.COHABITANT ||
    familySituation === FamilySituation.MARRIED
  ) {
    const cohabitantText = getText(
      "advicepage.death.cardadvicesharedchildrencohabitant",
    );
    const marriedText = getText(
      "advicepage.death.cardadvicesharedchildrenmarried",
    );
    const addCommentText = getText(
      "advicepage.death.cardadvicesharedchildrenaddcomment",
    );

    const phoneNumber = getText(
      partnerId === Partner.DANSKE_BANK
        ? AlertDescription.PHONENUMBER_DANSKE_BANK
        : AlertDescription.PHONENUMBER_STOREBRAND,
    );
    const contactUsText = getText(
      "advicepage.death.cardadvicesharedchildrencontactus",
      { variables: { phoneNumber } },
    );

    const spouseOrCohabitant =
      familySituation === FamilySituation.COHABITANT
        ? cohabitantText
        : marriedText;
    const isAdvisorText = isAdvisor ? addCommentText : contactUsText;

    const title = getText("advicepage.death.cardadvicesharedchildren", {
      variables: {
        advice_card_death_reason_spouse_cohabitant: spouseOrCohabitant,
      },
    });
    const buttonName = getText(
      "advicepage.death.cardadvicesharedchildrenreadmore",
    );
    const description = getText(
      "advicepage.death.cardadvicesharedchildrendesc",
      {
        variables: {
          advice_card_death_reason_spouse_cohabitant: spouseOrCohabitant,
          advice_card_death_reason_is_advisor: isAdvisorText,
        },
      },
    );
    return (
      <ReadMore title={title} buttonName={buttonName}>
        <DescriptionNoMargin>{description}</DescriptionNoMargin>
      </ReadMore>
    );
  }
  return null;
};
